import tagularEvents from "./tagular-events";

// prettier-ignore
const tagularModule = {
  generateUniqueId() {
    // generate uuidv4 ID number
    // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },

  setPageRank(listOfObjects) {
    if (!listOfObjects) {
      throw new Error({
        function: 'tagular_module.set_page_rank',
        error: 'This function needs a list of objects.'
      })
    }

    let listToReturn = []
    let pageRank = 1

    for (let i = 0; i < listOfObjects.length; i++) {
      listOfObjects[i].page_rank = pageRank
      listToReturn.push(listOfObjects[i])
      pageRank++
    }

    return listToReturn
  },

  setClickId(listOfObjects) {
    if (!listOfObjects) {
      throw new Error({
        function: 'tagular_module.set_page_rank',
        error: 'This function needs a list of objects.'
      })
    }

    let listToReturn = []

    for (let i = 0; i < listOfObjects.length; i++) {
      let clickId = this.generateUniqueId()

      listOfObjects[i].click_id = clickId
      listToReturn.push(listOfObjects[i])
    }

    return listToReturn
  },

  formSubmitted(formId, formName, formFields, formType) {
    if (!formId || !formName || !formFields) {
      throw new Error({
        function: 'tagular_module.form_submitted',
        error: 'All parameters must have values'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormSubmitted', {
        '@type': 'redventures.usertracking.v3.FormSubmitted',
        formContext: {
          formType: formType || 'LEAD',
          formName: formName
        },
        correlationId: formId,
        field: formFields
      })
    }
  },

  elementClicked(webElement, actionOutcome, outboundUrl, correlationId, alternateType) {
    tagularEvents.elementClicked(webElement, actionOutcome, outboundUrl, correlationId, alternateType)
  },

  elementViewed(webElement) {
    tagularEvents.elementViewed(webElement)
  },

  productClicked(
    productId,
    productName,
    productLocation,
    productRank,
    productVariant,
    clickId,
    productCategory
  ) {
    if (
      !productId ||
      !productName ||
      !productLocation ||
      !productRank ||
      !clickId
    ) {
      throw new Error({
        function: 'tagular_module.product_clicked',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'ProductClicked', {
        '@type': 'redventures.ecommerce.v1.ProductClicked',
        product: {
          productId: String(productId),
          category: productCategory,
          name: productName,
          location: productLocation,
          position: parseInt(productRank),
          variant: String(productVariant)
        },
        listId: productVariant,
        correlationId: clickId
      })
    }
  },

  fieldSelected(formName, fieldId, fieldName, fieldValue, fieldLabel, formId) {
    if (!formName || !fieldId || !fieldName || !fieldLabel) {
      throw new Error({
        function: 'tagular_module.field_selected',
        error: 'All parameters must have values'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FieldSelected', {
        '@type': 'redventures.usertracking.v3.FieldSelected',
        userInputField: {
          fieldName: fieldName,
          fieldId: fieldId,
          fieldValue: String(fieldValue),
          fieldLabel: fieldLabel
        },
        formContext: {
          formType: 'LEAD',
          formName: formName,
          formId: formId
        }
      })
    }
  },

  fieldInputted(formName, fieldId, fieldName, fieldValue, fieldLabel, formId, formType = null, fieldType = null) {
    if (!formName || !fieldId || !fieldName || !fieldValue) {
      throw new Error({
        function: 'tagular_module.field_inputted',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FieldInputted', {
        '@type': 'redventures.usertracking.v3.FieldInputted',
        userInputField: {
          fieldName: fieldName,
          fieldId: fieldId,
          fieldValue: String(fieldValue),
          fieldLabel: fieldLabel,
          ...(fieldType && { fieldType })
        },
        formContext: {
          formType: formType || 'LEAD',
          formName: formName,
          formId: formId
        }
      })
    }
  },

  productViewed: function(
    productId,
    productName,
    productRank,
    formId,
    productCategory,
    location
  ) {
    if (!productId || !productName || !productRank) {
      throw new Error({
        function: 'tagular_module.product_viewed',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'ProductViewed', {
        '@type': 'redventures.ecommerce.v1.ProductViewed',
        product: {
          productId: String(productId),
          category: productCategory,
          name: productName,
          position: parseInt(productRank),
          variant: String(formId),
          location: location
        },
        listId: formId
      })
    }
  },

  productListViewed: function(listId, category, productList, fields){
    if(typeof tagular !== 'undefined') {
      tagular('beam', 'ProductListViewed', {
        '@type': 'redventures.ecommerce.v1.ProductListViewed',
        listId: listId,
        category: category,
        product: productList,
        ...(fields && { fields })
      })
    }
  },

  formViewed(formType, formName, formId) {
    if (!formType || !formName || !formId) {
      throw new Error({
        function: 'tagular_module.formViewed',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormViewed', {
        '@type': 'redventures.usertracking.v3.FormViewed',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        }
      })
    }
  },

  formStarted(formType, formName, formId) {
    if (!formType || !formName || !formId) {
      throw new Error({
        function: 'tagular_module.formStarted',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormStarted', {
        '@type': 'redventures.usertracking.v3.FormStarted',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        }
      })
    }
  },

  formContinued(formType, formName, formId) {
    if (!formType || !formName || !formId) {
      throw new Error({
        function: 'tagular_module.formContinued',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormContinued', {
        '@type': 'redventures.usertracking.v3.FormContinued',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        }
      })
    }
  }
}

export default tagularModule
